var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaidIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 97,
    viewBox: "0 0 85 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 81.25C65.7218 81.25 84.5469 63.2295 84.5469 41C84.5469 18.7705 65.7218 0.75 42.5 0.75C19.2782 0.75 0.453125 18.7705 0.453125 41C0.453125 63.2295 19.2782 81.25 42.5 81.25Z",
    fill: "#222831"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M42.5 9.5C47.2111 9.5 51.0447 6.07525 51.5419 1.69325C48.6279 1.0825 45.606 0.75 42.5 0.75C19.2773 0.75 0.453125 18.7698 0.453125 41C0.453125 43.9733 0.800468 46.866 1.43848 49.6555C6.01794 49.1795 9.59375 45.5098 9.59375 41C9.59375 23.6313 24.3559 9.5 42.5 9.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M83.5615 32.3445C78.9821 32.8205 75.4063 36.4902 75.4063 41C75.4063 58.3687 60.6441 72.5 42.5 72.5C37.7889 72.5 33.9553 75.9247 33.4581 80.3067C36.3721 80.9175 39.394 81.25 42.5 81.25C65.7227 81.25 84.5469 63.2302 84.5469 41C84.5469 38.0267 84.1995 35.134 83.5615 32.3445Z",
    fill: "#222831"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M42.5 97C61.6833 97 77.2344 94.6495 77.2344 91.75C77.2344 88.8505 61.6833 86.5 42.5 86.5C23.3167 86.5 7.76562 88.8505 7.76562 91.75C7.76562 94.6495 23.3167 97 42.5 97Z",
    fill: "#222831"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 72.5C60.6736 72.5 75.4062 58.397 75.4062 41C75.4062 23.603 60.6736 9.5 42.5 9.5C24.3264 9.5 9.59375 23.603 9.59375 41C9.59375 58.397 24.3264 72.5 42.5 72.5Z",
    fill: "#00ADB5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5078 25.9972C14.941 19.524 20.5241 14.2635 27.3503 11.0837",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8603 58.682L17.4492 43.8823C16.7234 43.1858 16.7234 42.0553 17.4492 41.3588L22.7051 36.3118C23.4308 35.6153 24.6081 35.6153 25.3339 36.3118L36.5495 47.0813L59.2694 22.3538C59.9476 21.6153 61.1231 21.5435 61.8928 22.1963L67.4667 26.9195C68.2363 27.5723 68.3095 28.6993 67.6312 29.4378L40.9827 58.4388C38.8565 60.754 35.1345 60.866 32.8603 58.682Z",
    fill: "#222831"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaidIcon);
export default __webpack_public_path__ + "static/media/PaidIcon.de9b9a033d4b25f870085f975181dfef.svg";
export { ForwardRef as ReactComponent };